import { render } from "./CredenciamentoCpf.vue?vue&type=template&id=2bd603b4&scoped=true"
import script from "./CredenciamentoCpf.vue?vue&type=script&lang=js"
export * from "./CredenciamentoCpf.vue?vue&type=script&lang=js"

import "./CredenciamentoCpf.vue?vue&type=style&index=0&id=2bd603b4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd603b4"]])

export default __exports__